import { SET_CURRENT_THEME } from '@greenkub-fronts/domain/ui';
import { GROUP_NAME, UiTheme } from '@greenkub-fronts/shared/interface';
import { ChosenOptionList } from '@greenkub-fronts/shared/interface';
import { createAsyncThunk } from '@reduxjs/toolkit';

import { getCurrentProject } from '../../customer-area.slice';

export const initCurrentProject = createAsyncThunk(
  'initCurrentProject',
  async (
    data: { refetch?: boolean },
    { dispatch, extra, getState }: { dispatch: any; extra: any; getState: any }
  ) => {
    if (data.refetch) {
      await dispatch(
        extra.apiSlice.endpoints.getAllCustomerProjects.initiate(
          {
            groupName: GROUP_NAME.PROJECTS_FOR_CUSTOMER_AREA,
          },
          {
            forceRefetch: true,
          }
        )
      );
    }

    const currentProject = getCurrentProject(getState());

    if (!currentProject) return;

    /**
     * Fetch task
     */
    dispatch(
      extra.apiSlice.endpoints.getCustomerTasksByProject.initiate({
        projectId: currentProject?.id,
        groupName: GROUP_NAME.TASK_FOR_CUSTOMER_AREA,
      })
    );

    /**
     * Fetch document
     */
    dispatch(
      extra.apiSlice.endpoints.getCustomerDocumentsByProject.initiate({
        projectId: currentProject?.id,
        groupName: GROUP_NAME.DOCUMENT_FOR_CUSTOMER_AREA,
      })
    );

    const isKit =
      currentProject.configurations[0].chosenStudioList.studio.name.includes(
        'KIT'
      );

    dispatch({
      type: SET_CURRENT_THEME,
      payload: {
        currentTheme: isKit ? UiTheme.GEKA : UiTheme.GK,
      },
    });

    /**
     * placer les options dans le state
     */
    let processedOptions: any = undefined;
    if (isKit) {
      processedOptions = {
        terrasse: currentProject.configurations[0].chosenOptionLists.find(
          (chosenOptionList: ChosenOptionList) =>
            [
              '0110-00330',
              '0110-00329',
              '0110-00324',
              '0110-00325',
              '0110-00338',
              '0110-00336',
              '0110-00334',
              '0110-00331',
            ].includes(chosenOptionList.catalogue.defaultCode ?? '')
        ),
        pergola: currentProject.configurations[0].chosenOptionLists.find(
          (chosenOptionList: ChosenOptionList) =>
            [
              '0110-00328',
              '0110-00327',
              '0110-00326',
              '0110-00332',
              '0110-00340',
              '0110-00337',
              '0110-00335',
              '0110-00333',
            ].includes(chosenOptionList.catalogue.defaultCode ?? '')
        ),
        bardage: currentProject.configurations[0].chosenOptionLists.find(
          (chosenOptionList: ChosenOptionList) =>
            [
              '0110-00317',
              '0110-00318',
              '0110-00303',
              '0110-00302',
              '0110-00306',
              '0110-00304',
              '0110-00305',
            ].includes(chosenOptionList.catalogue.defaultCode ?? '')
        ),
        toitureVege: currentProject.configurations[0].chosenOptionLists.find(
          (chosenOptionList: ChosenOptionList) =>
            [
              '0200-00143',
              '0200-00139',
              '0200-00138',
              '0200-00137',
              '0200-00136',
              '0200-00134',
              '0200-00144',
            ].includes(chosenOptionList.catalogue.defaultCode ?? '')
        ),
        menuiserieAnthra:
          currentProject.configurations[0].chosenOptionLists.find(
            (chosenOptionList: ChosenOptionList) =>
              chosenOptionList.catalogue.defaultCode === '0600-01244'
          ),
        accompagnement: currentProject.configurations[0].chosenOptionLists.find(
          (chosenOptionList: ChosenOptionList) =>
            chosenOptionList.catalogue.defaultCode === '1300-00025'
        ),
        aideDechargement:
          currentProject.configurations[0].chosenOptionLists.find(
            (chosenOptionList: ChosenOptionList) =>
              chosenOptionList.catalogue.defaultCode === '1300-00026'
          ),
        forfaitCoaching:
          currentProject.configurations[0].chosenOptionLists.find(
            (chosenOptionList: ChosenOptionList) =>
              chosenOptionList.catalogue.defaultCode === '1300-00024'
          ),
        taillePergola: currentProject.configurations[0].chosenOptionLists.find(
          (chosenOptionList: ChosenOptionList) =>
            chosenOptionList.catalogue.defaultCode === '0110-00308'
        ),
        tailleTerrasse: currentProject.configurations[0].chosenOptionLists.find(
          (chosenOptionList: ChosenOptionList) =>
            chosenOptionList.catalogue.defaultCode === '0110-00307'
        ),
      };
    }

    return { processedOptions };
  }
);
